import ZipForm from '~components/ZipCodeForm/ZipCodeForm';
import useWindowSize from '~hooks/useWindowSize';

export const CarrierPartnerContent = ({ partnerDisplayName }: { partnerDisplayName?: string }) => {
    const subheadingH2 = `Compare Medicare Advantage plans${
        partnerDisplayName ? ' from ' + partnerDisplayName : ''
    }`;
    const subheadingP = `The doctors you have, prescriptions you need and benefits you want — compare${
        partnerDisplayName ? ' ' + partnerDisplayName + ' ' : ' '
    }plans and enroll with no fee and no obligation.`;

    return (
        <>
            <h1 className="font-poppins font-bold">Find your Medicare match</h1>
            <h2 className="font-poppins font-bold">{subheadingH2}</h2>
            <p className="text-18 leading-28 md:!block md:pb-8 lg:pb-0">{subheadingP}</p>
        </>
    );
};

const CarrierPartner = ({ partnerDisplayName }: { partnerDisplayName?: string }) => {
    const { isDesktop } = useWindowSize();
    const ctaText =
        isDesktop && partnerDisplayName
            ? `Compare ${partnerDisplayName.slice(0, 10)} plans`
            : 'Compare plans';
    const subheadingP = `The doctors you have, prescriptions you need and benefits you want — compare${
        partnerDisplayName ? ' ' + partnerDisplayName + ' ' : ' '
    }plans and enroll with no fee and no obligation.`;
    return (
        <section className="hero-paid-search-carrier-partner">
            <div className="bg-surface-light md:bg-transparent p-4 md:p-0 mt-0 lg:mt-6 rounded-lg drop-shadow-elevation-shadow-overlay md:filter-none flex justify-center">
                <div className="max-w-screen-xs md:max-w-screen-xl w-full">
                    <p className="md:hidden text-16 leading-24 pb-6">{subheadingP}</p>
                    <div className="mb-6 md:mb-2 lg:mb-6">
                        <ZipForm
                            buttonTitle={ctaText}
                            buttonWaLink="Hero Carrier Partner: Compare Plan"
                            qaValue="Hero Carrier Partner"
                            opts={{
                                btnStyle: 'primary',
                                useWideLayout: true,
                            }}
                        />
                    </div>
                </div>
            </div>
        </section>
    );
};

export default CarrierPartner;
